import {
  IVerdragsbijdrageClient,
  VerdragsbijdrageClient
} from "./rekenmodule-eigenbijdrage.client.generated";
import axios, { AxiosInstance } from "axios";

export class ClientFactory {
  private readonly baseUrl: string;
  private readonly instance?: AxiosInstance;

  constructor(apiUrl) {
    this.baseUrl = apiUrl;
    this.instance = axios;
  }

  getClient = (): IVerdragsbijdrageClient => {
    return new VerdragsbijdrageClient(this.baseUrl, this.instance);
  };
}
